import React, { ReactNode, useEffect } from 'react';
import { Banner, Flex, Icon, Text } from '@pega/cosmos-react-core';
import { useDispatch, useSelector } from 'react-redux';
import { resetBannerInfo } from '../../redux/actions';
import { InteractiveText } from './custom.styled';
import { Navigate, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import { appState } from '../../interfaces/common';
import useLocalTranslation from '../../hooks/useLocalTranslation';

interface SectionRenderTemplateProps {
  header?: ReactNode;
  hideNavigation?: boolean;
  children: ReactNode;
}
const SectionRenderTemplate: React.FC<SectionRenderTemplateProps> = (props) => {
  const { header, hideNavigation = false, children } = props;
  const dispatch = useDispatch();
  const bannerInfo = useSelector((state: appState) => state.bannerInfo);
  const getBannerMessage = <Text style={{ fontWeight: 'bold' }}>{bannerInfo.message}</Text>;
  const navigate = useNavigate();
  const translate = useLocalTranslation();
  const params = queryString.parseUrl(window.location.toString());

  const routetoPath = () => {
    navigate('/');
  };

  useEffect(() => {
    return () => {
      dispatch(resetBannerInfo());
    };
  }, [dispatch]);

  return (
    <>
      {params.query.session_id ? (
        <Navigate to={`${window.location.pathname}`} />
      ) : (
        <>
          <Flex
            style={{ margin: bannerInfo.message ? '1rem' : '1.5rem 1rem' }}
            container={{
              direction: 'column',
              justify: 'between',
              itemGap: 1.5,
            }}
          >
            {bannerInfo.message && !bannerInfo.forMonitorTab && (
              <Banner
                id="banner"
                action={getBannerMessage}
                variant={bannerInfo.variant}
                messages={[]}
                onDismiss={() => {
                  dispatch(resetBannerInfo());
                }}
                heading={bannerInfo.heading}
                style={{ marginBottom: '1rem' }}
              />
            )}
            {!hideNavigation && (
              <InteractiveText className="pointer" onClick={routetoPath}>
                <Icon name="arrow-left" />
                {` ${translate('home')}`}
              </InteractiveText>
            )}
            <Flex
              container={{
                direction: 'column',
                justify: 'between',
                itemGap: 2,
              }}
            >
              {header}
              {children}
            </Flex>
          </Flex>
        </>
      )}
    </>
  );
};

export default React.memo(SectionRenderTemplate);
